import { MapSetupState, MapSetupGroup } from "./types";

export function getDefaultState(): MapSetupState {
    return {
        GroupsWithLayers: [],
        SelectedMapLayerId: null,
        unconvertedMaps: [],
        notificationOptions: null
    }
}
